import archidekt from '@/assets/svgs/archidekt.svg'
import { ButtonDefault } from '@/components/common/Button'
import { IconImage } from '@/components/icons/IconImage'
import { type RecType } from '@/defs/rec'
import { useArchidektLink } from '@/hooks/useArchidektLink'

import styles from './ArchidektPlaytester.module.scss'

type Props = {
  recs: RecType[]
}

export const ArchidektPlaytester = ({ recs }: Props) => {
  const { href, loading, onClick, onInteract } = useArchidektLink({ link: 'playtester', recs })

  return (
    <ButtonDefault
      as='LinkOutbound'
      colorScheme='archidekt'
      href={href}
      loading={loading}
      maxwidth
      onClick={onClick}
      onFocus={onInteract}
      onPointerEnter={onInteract}
      utm={false}
    >
      <div className={styles.container}>
        <IconImage className={styles.icon} src={archidekt.src} />
        <span>Playtest on Archidekt</span>
      </div>
    </ButtonDefault>
  )
}
